<template>
  <!--发现-->
  <div class="findList">
    <!--top-->
    <div class="top">
      <div class="top_title">发现</div>
      <img
        v-if="themeName == 'dark'"
        src="@/asstes/findlist/sixth.png"
        @click="handleCustomer"
      />
      <img
        v-if="themeName == 'white'"
        src="@/asstes/findlist/sixth-white.png"
        @click="handleCustomer"
      />
    </div>

    <!--banner-->
    <Banner />
    <div
      class="tabList"
      v-if="0"
    >
      <div class="tabList_title">
        <span>知识充电站</span>
        <img
          v-if="themeName == 'dark'"
          src="@/asstes/dataCenter/circular.png"
        />
        <img
          v-if="themeName == 'white'"
          src="@/asstes/dataCenter/circular-white.png"
        />
      </div>
      <div
        class="tabList_body"
        style="margin-bottom: 30px"
      >
        <van-swipe
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
          :show-indicators="false"
          :loop="false"
        >
          <van-swipe-item
            v-for="(item, index) in list"
            @click="clickItem(index)"
            :key="index"
          >
            <img
              :src="item"
              style="width: 100%; height: 100%"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!--tabs-->
    <div
      class="tabList"
      v-if="isCoupon"
    >
      <div class="tabList_title">
        <span>活动专区</span>
        <img
          v-if="themeName == 'dark'"
          src="@/asstes/dataCenter/circular.png"
        />
        <img
          v-if="themeName == 'white'"
          src="@/asstes/dataCenter/circular-white.png"
          style="width: 6px; height: 6px"
        />
      </div>
      <div
        class="tabList_body"
        style="margin-bottom: 30px; border-radius: 20px; overflow: hidden"
        @click="goAli()"
      >
        <img
          src="@/asstes/999.png"
          style="width: 100%; height: 130px"
        />
      </div>
    </div>
    <div class="tabList">
      <div class="tabList_title">
        <span>充电小百科</span>
        <img
          v-if="themeName == 'dark'"
          src="@/asstes/dataCenter/circular.png"
        />
        <img
          v-if="themeName == 'white'"
          src="@/asstes/dataCenter/circular-white.png"
          style="width: 6px; height: 6px"
        />
      </div>
      <div class="tabList_body">
        <div
          class="tabList_body_item"
          v-for="(item, index) in tableList"
          :key="index"
          @click="handlePath(item.path)"
        >
          <img :src="item.img" />
          <div class="item_title">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <!--客服-->
    <el-drawer
      title="服务时间9:00 ~ 21:00"
      :visible.sync="drawer"
      :direction="direction"
      :modal="false"
      :show-close="false"
      :wrapperClosable="false"
    >
      <div
        class="telephone"
        @click.to="callPhone('4006596580')"
      >
        电话客服 400-659-6580
      </div>
      <div
        class="cancel"
        @click="cancel"
      >
        取 消
      </div>
    </el-drawer>
    <!-- 弹框 -->
    <van-dialog
      v-model="show"
      :show-cancel-button="false"
      :showConfirmButton="false"
      :width="330"
      :overlay="false"
    >
      <div class="popsty">
        <div style="margin-bottom: 15px">信息同步通知</div>
        <div>挚达携手商业知识服务平台“复旦商业知识”，同步您的APP账号数据</div>
        <div style="margin-bottom: 10px">
          为了让您更便捷地体验【知识充电站】模块的丰富功能，挚达诚挚邀请您与“复旦商业知识”同步您的APP账号数据。通过这一同步，您将在挚达小程序中轻松获取充电行业的最新资讯与专业知识。
        </div>
        <div style="text-align: left; width: 100%">
          隐私安全，我们为您保驾护航
        </div>
        <div style="margin-bottom: 20px">
          我们深知您的信息安全至关重要，因此，挚达将确保您的数据传输安全。
        </div>
        <div class="botom">
          <van-checkbox v-model="checked">
            <div class="xieyi">
              <div class="">
                勾选即同意<span
                  @click="toAgreement"
                  style="color: #1677ff"
                  >《挚达APP知识充电站隐私协议》</span
                >
              </div>
            </div>
          </van-checkbox>
        </div>
        <div class="btnss">
          <div @click="show = false">取消</div>
          <div @click="goPermisson">立即授权</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Banner from "./banner";
export default {
  components: {
    Banner,
  },
  data() {
    return {
      tableList: [
        {
          id: 1,
          img: require("@/asstes/findlist/first.png"),
          name: "说明书",
          // path: 'instruction'
          path: "1",
        },
        {
          id: 2,
          img: require("@/asstes/findlist/second.png"),
          name: "常见问题",
          path: "problem",
        },
        {
          id: 3,
          img: require("@/asstes/findlist/third.png"),
          name: "相关安装",
          path: "installRelated",
        },
        {
          id: 4,
          img: require("@/asstes/findlist/fourth.png"),
          name: "APP使用",
          path: "useInfo",
        },
        // {
        //     id: 5,
        //     img: require('@/asstes/findlist/fifth.png'),
        //     name: '商城',
        //     path: '2'
        // },
      ],
      checked: false,
      editionList: [
        {
          id: 1,
          name: "数字交流桩-基础版",
        },
        {
          id: 2,
          name: "数字交流桩-4G版",
        },
        {
          id: 3,
          name: "数字交流桩-基础版",
        },
        {
          id: 4,
          name: "数字交流桩-基础版",
        },
      ],
      drawer: false,
      direction: "btt",
      imgShow: false,
      imgCircularPath: "",
      list: ["https://img.cdn.wxzhida.cn/zd-ali-app/asdafee.png"],
      show: false,
      isCoupon: false,
    };
  },
  computed: {
    themeName() {
      return "white";
    },
    userPhone() {
      return this.$store.state.userPhone;
    },
  },
  mounted() {
    this.getDetail();
    this.appDown();
  },
  methods: {
    getDetail() {
      let u = navigator.userAgent;
      // android 终端
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // ios 终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let _ = this;
      if (isiOS) {
        window["getToken"] = (value) => {
          let flag = value.split(",");
          console.log("ssssss");
          console.log(flag);
          console.log("ssssss");
          _.$store.commit("setPhone", flag[0]); // 手机号
          _.$store.commit("setToken", flag[1]); // token

          _.$H
            .post(_, _.$A.knowledge.detail, {
              corpNo: "CO1524100773815",
              userPhone: flag[0],
            })
            .then((res) => {
              if (res.data.data != null) {
                _.isCoupon = res.data.data.isCoupon;
              }
            });
        };
      } else if (isAndroid) {
        _.$store.commit("setPhone", window.jsBridge.getPhone()); // 手机号
        _.$store.commit("setToken", window.jsBridge.getToken()); // token
        _.$H
          .post(_, _.$A.knowledge.detail, {
            corpNo: "CO1524100773815",
            userPhone: _.$store.state.userPhone,
          })
          .then((res) => {
            if (res.data.data != null) {
              _.isCoupon = res.data.data.isCoupon;
            }
          });
      }
    },
    goAli() {
      // console.log("xxx");
      // window.open("https://ur.alipay.com/_3wZZavHoQ2P5atZU8PVTIQ", "_self");
      // let u = navigator.userAgent;
      let _ = this;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        _.isApple = true;
        window.webkit.messageHandlers.app_externalLink.postMessage(
          "https://ur.alipay.com/_3wZZavHoQ2P5atZU8PVTIQ"
        );
      } else if (isAndroid) {
        _.isApple = false;
        window.jsBridge.app_externalLink(
          "https://ur.alipay.com/_3wZZavHoQ2P5atZU8PVTIQ"
        );
      }
    },
    // 判断是安卓还是ios
    appDown() {
      let _ = this;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        _.isApple = true;
        window.webkit.messageHandlers.showTabbar.postMessage("");
      } else if (isAndroid) {
        _.isApple = false;
        window.jsBridge.showTabbar();
      }
    },
    handlePath(path) {
      let _ = this;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // if(path){
      //     _.$router.push({name: path})
      // }else {
      //     _.$U.showMsg("敬请期待！")
      // }
      if (path === "1") {
        if (isiOS) {
          _.isApple = true;
          window.webkit.messageHandlers.goFunction.postMessage("");
        } else if (isAndroid) {
          _.isApple = false;
          window.jsBridge.goFunction();
        }
      } else if (path === "2") {
        let val = "https://j.youzan.com/CNmtQ1";
        _.$store.commit("setBannerUrl", val);
        _.$router.push({ name: "bannerUrl" });
        // if(isiOS){
        //     _.isApple = true;
        //     window.webkit.messageHandlers.goShopping.postMessage('');
        // }else if(isAndroid){
        //     _.isApple = false;
        //     window.jsBridge.goShopping();
        // }
      } else {
        _.$router.push({ name: path });
      }
    },
    // 客服
    handleCustomer() {
      this.drawer = true;
    },
    cancel() {
      this.drawer = false;
    },
    // 拨打电话
    callPhone(phone) {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      console.log("ios 01", phone);
      if (isiOS) {
        window.webkit.messageHandlers.callPhone.postMessage(phone);
      } else if (isAndroid) {
        window.jsBridge.callPhone(phone);
      }
    },
    // 点击轮播图
    clickItem(index) {
      console.log(index);
      console.log("点击了轮播图1");
      let _ = this;
      _.$H
        .post(_, _.$A.fudan.isAgree, {
          accessType: "alipay-mini-program",
          data: {},
        })
        .then((res) => {
          if (!res.data) {
            // 未同意
            _.$H
              .post(_, _.$A.fudan.isFind, {
                // 发现进入统计
                accessType: "alipay-mini-program",
                data: true,
              })
              .then((res) => {
                // 发现进入统计
                _.show = true;
              });
          } else {
            // 已同意 直接进入
            _.$H
              .post(_, _.$A.fudan.isFind, {
                // 发现进入统计
                accessType: "alipay-mini-program",
                data: true,
              })
              .then((res) => {
                let token = _.$store.state.token;
                console.log(token);
                let u = navigator.userAgent;
                // android 终端
                let isAndroid =
                  u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                // ios 终端
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                // 发现进入统计
                if (isAndroid) {
                  window.jsBridge.app_externalLink(
                    "https://web-charge.shzhida.com/zd-zf-h5/"
                  );
                }
                if (isiOS) {
                  console.log("iossssss11111");
                  window.webkit.messageHandlers.app_externalLink.postMessage(
                    "https://web-charge.shzhida.com/zd-zf-h5/"
                  );
                }
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goPermisson() {
      let that = this;
      if (!this.checked) {
        that.$U.showMsg("请阅读并勾选协议");
        return;
      }
      that.$H
        .post(that, that.$A.fudan.agree, {
          // 授权
          accessType: "alipay-mini-program",
          data: true,
        })
        .then((res) => {
          this.show = false;
          let token = that.$store.state.token;
          console.log(token);
          let u = navigator.userAgent;
          // android 终端
          let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
          // ios 终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          // 发现进入统计
          if (isAndroid) {
            window.jsBridge.app_externalLink(
              "https://web-charge.shzhida.com/zd-zf-h5/"
            );
            // window.open(
            //   `https://web-charge.shzhida.com/zd-zf-h5/?token=${token}`
            // );
          }
          if (isiOS) {
            console.log("iossssss");
            window.webkit.messageHandlers.app_externalLink.postMessage(
              "https://web-charge.shzhida.com/zd-zf-h5/"
            );
          }
        });
    },
    toAgreement() {
      window.open(
        "https://img.cdn.wxzhida.cn/ali-h5/zf-knowledge-privacy-app.html"
      );
    },
  },
};
</script>

<style
  lang="less"
  scoped
>
.findList {
  padding: 51px 25px 0 25px;
  box-sizing: border-box;
  background-color: #f6f5f8;

  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    padding-bottom: 32px;
    box-sizing: border-box;

    .top_title {
      font-size: 24px;
      font-weight: 600;
    }

    img {
      width: 6%;
    }
  }

  .tabList {
    display: flex;
    flex-wrap: wrap;

    .tabList_title {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 24px;
      box-sizing: border-box;

      span {
        padding-right: 10px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
      }

      img {
        width: 3%;
      }
    }

    .tabList_body {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .tabList_body_item {
        width: calc(33.33% - 16px);
        height: auto;
        /* background-color: @primary-module-background-color; */
        box-shadow: 0 0 18px @primary-box-shadow;
        border-radius: 10px;
        padding: 12px 16px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 24px;
        background-color: #ffffff;

        img {
          width: 48px;
          height: 48px;
        }

        div {
          width: 100%;
          text-align: center;
          font-size: 14px;
          padding-top: 16px;
          box-sizing: border-box;
        }
      }

      .tabList_body_item:hover {
        cursor: pointer;
      }

      .tabList_body_item:nth-child(2) {
        margin: 0 24px 24px 24px;
      }

      .tabList_body_item:nth-child(5) {
        margin: 0 24px 24px 24px;
      }
    }
  }

  /deep/ .el-drawer {
    background-color: @primary-drawer-background;
    color: @primary-text-color;
    box-shadow: 0px 2px 15px 7px @primary-drawer-box-shadow;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
    height: auto !important;
    background-color: #ffffff !important;
  }

  /deep/ .el-drawer__header {
    color: @primary-text-color;
    font-size: 14px;
    padding: 25px;
    margin-bottom: 0;
    text-align: center;
  }

  /deep/ .el-drawer__body {
    padding: 0 48px;
    box-sizing: border-box;
  }

  .telephone {
    font-size: 18px;
    color: #1578ff;
    text-align: center;
    margin-bottom: 30px;
  }

  .cancel {
    width: 100%;
    height: 56px;
    background-color: #1578ff;
    font-size: 14px;
    text-align: center;
    line-height: 56px;
    color: white;
    border-radius: 20px;
    margin-bottom: 24px;
  }
}

.popsty {
  padding: 20px;
  font-weight: 400;
  font-size: 12px;
  color: #2d3748;
  line-height: 17px;

  .xieyi {
    font-weight: 400;
    font-size: 12px;
    color: #bcbcc1;
  }

  > div {
    &:nth-child(1) {
      width: 100%;
      font-weight: 600;
      font-size: 14px;
      color: #2d3748;
      line-height: 20px;
      text-align: center;
    }

    &:nth-child(2) {
      width: 100%;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }

  .btnss {
    width: 100%;
    display: flex;
    margin-top: 25px;
    justify-content: space-between;

    > div {
      width: 105px;
      height: 40px;
      border-radius: 23px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #1677ff;
      &:nth-child(1) {
        color: #1677ff;
      }

      &:nth-child(2) {
        color: #ffffff;
        background: #1677ff;
      }
    }
  }
}
</style>
